interface Answer {
  id: string;
  answer: string;
  nextQuestionId: string;
  terminateFlow?: boolean;
}

interface Question {
  id: string;
  question: string;
  answersType: "radio" | "select";
  answers: Record<string, Answer>;
}

interface DecisionFlowConfig {
  firstQuestionId: string;
  questions: Record<string, Question>;
}

export const DECISION_FLOW_CONFIG: DecisionFlowConfig = {
  firstQuestionId: "152",
  questions: {
    "152": {
      id: "152",
      question: "Will your business activities be carried out in Australia?",
      answersType: "radio",
      answers: {
        "336": { id: "336", answer: "Yes", nextQuestionId: "139" },
        "337": { id: "337", answer: "No", nextQuestionId: "156" },
      },
    },
    "3": {
      id: "3",
      question: "What is the nature of your business?",
      answersType: "select",
      answers: {
        "339": { id: "339", answer: "Running a business", nextQuestionId: "143" },
        "338": {
          id: "338",
          answer: "Apprentice, trade assistant or labourer",
          nextQuestionId: "0",
          terminateFlow: true,
        },
        "340": { id: "340", answer: "Renting or leasing out a residential property", nextQuestionId: "5" },
        "341": { id: "341", answer: "A licence, lease or other grant of an interest in property", nextQuestionId: "6" },
        "344": {
          id: "344",
          answer: "One-off commercial transactions not carried out in the course of a business",
          nextQuestionId: "147",
        },
      },
    },
    "5": {
      id: "5",
      question: "Are you renting out residential property on a regular or continuous basis?",
      answersType: "radio",
      answers: {
        "11": { id: "11", answer: "Yes", nextQuestionId: "0" },
        "379": { id: "379", answer: "No", nextQuestionId: "0", terminateFlow: true },
      },
    },
    "6": {
      id: "6",
      question: "Do your business activities take place on a regular or continuous basis?",
      answersType: "radio",
      answers: {
        "13": { id: "13", answer: "Yes", nextQuestionId: "0" },
        "14": { id: "14", answer: "No", nextQuestionId: "0", terminateFlow: true },
      },
    },
    "135": {
      id: "135",
      question: "Are you applying for a 'GST Only' registration?",
      answersType: "radio",
      answers: {
        "299": { id: "299", answer: "Yes", nextQuestionId: "0" },
        "300": { id: "300", answer: "No", nextQuestionId: "0", terminateFlow: true },
      },
    },
    "139": {
      id: "139",
      question: "Have you started business or are you taking steps to begin trading?",
      answersType: "radio",
      answers: {
        "310": { id: "310", answer: "Yes", nextQuestionId: "3" },
        "311": { id: "311", answer: "No", nextQuestionId: "0", terminateFlow: true },
      },
    },
    "143": {
      id: "143",
      question: "Are you carrying out activities that show you're starting or running a business?",
      answersType: "radio",
      answers: {
        "318": { id: "318", answer: "Yes", nextQuestionId: "0" },
        "319": { id: "319", answer: "No", nextQuestionId: "0", terminateFlow: true },
      },
    },
    "147": {
      id: "147",
      question: "Do you expect to make a profit or gain from your activity?",
      answersType: "radio",
      answers: {
        "326": { id: "326", answer: "Yes", nextQuestionId: "0" },
        "327": { id: "327", answer: "No", nextQuestionId: "0", terminateFlow: true },
      },
    },
    "156": {
      id: "156",
      question: "Are you making supplies connected to the Indirect Tax Zone?",
      answersType: "radio",
      answers: {
        "364": { id: "364", answer: "Yes", nextQuestionId: "139" },
        "365": { id: "365", answer: "No", nextQuestionId: "135" },
      },
    },
  },
};

export const getNextQuestionId = (questionId: string, answerId: string): string => {
  const question = DECISION_FLOW_CONFIG.questions[questionId];
  if (!question) {
    return "0";
  }
  const answer = question.answers[answerId];
  return answer?.nextQuestionId ?? "0";
};
